import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
  
export default function ThankYou() {
  const navigate = useNavigate()
  const [score, setScore] = useState(null)
  const { t } = useTranslation()

  useEffect(() => {
    // Get the score from localStorage
    const lastScore = localStorage.getItem('lastGameScore')
    if (lastScore) {
      setScore(parseInt(lastScore, 10))
    }
  }, [])

  return (
    <div className="text-[60px] text-left w-[620px] h-[1060px] mx-auto mt-[210px]">
      <div className="flex flex-col w-[640px] mx-auto items-start justify-center">

        <h1 className="w-[1000px] text-[66px] text-white uppercase font-euclid-circular-b-bold mt-[20px] -mb-[10px]">{t('thankYou')}</h1>
        {score !== null && (
          <p className="text-[186px] leading-[1] w-full flex items-start justify-start mb-[40px] font-euclid-circular-b-bold text-[#ffab54]">
            {score}
          </p>
        )}
        <p className="text-white leading-[1.2] text-[48px] font-euclid-circular-b-regular mb-[20px]" dangerouslySetInnerHTML={{ __html: t('thankYouDescription') }} />
        <p className="text-white leading-[1.2] text-[48px] font-euclid-circular-b-regular w-[700px]" dangerouslySetInnerHTML={{ __html: t('thankYouDescription2') }} />
        <button
          type="button"
          className="bg-[#ffab54] absolute bottom-[270px] left-[235px] w-[379px] h-[93px] flex items-center justify-center cursor-pointer rounded-[10px] disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => navigate('/leaderboard')}
        >
          <span className="relative z-10 text-[#000b48] text-[48px] font-euclid-circular-b-semibold">{t('next')}</span>
        </button>
      </div>
    </div>
  )
}